import * as React from 'react';
import { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import {
  Wrapper,
  Content,
  Page,
  ActionPage
} from './styled';
import { PAGE } from './contants';
import { Icon } from './../Icon';
import { Shimmer } from './../Shimmer';

interface Props {
  loading?: boolean;
  defaultPage?: number;
  totalPages: number;
  range?: number;
  onClickFirstPage?: Function;
  onClickPrevPage?: Function;
  onClickNextPage?: Function;
  onClickLastPage?: Function;
  onClickCurrentPage?: Function;
}

export const Pagination: React.FC<Props> = ({
  loading,
  defaultPage = 1,
  totalPages,
  range = 4,
  onClickFirstPage,
  onClickPrevPage,
  onClickNextPage,
  onClickLastPage,
  onClickCurrentPage
}) => {
  if(defaultPage > totalPages) {
    defaultPage = 1;
  }
  let start = defaultPage <= range ? PAGE.FIRST : defaultPage - range + 1;
  let end = totalPages <= range ? totalPages : start + range - 1;
  const [ page, setPage ] = useState(defaultPage);
  const [ total, setTotal ] = useState(totalPages);
  const [ startRange, setStartRange ] = useState(start);
  const [ endRange, setEndRange ] = useState(end);

  useEffect(() => {
    setPage(defaultPage);
    setTotal(totalPages);
    setStartRange(start);
    setEndRange(end);
  });

  let items = [];

  for(let count=startRange; count<=endRange; count++) {
    items.push(count);
  }

  const handleFirstPage = () => {
    setPage(PAGE.FIRST);
    setStartRange(PAGE.FIRST);
    range > total ? setEndRange(total) : setEndRange(range);
    onClickFirstPage && onClickFirstPage(PAGE.FIRST);
  };

  const handlePrevPage = () => {
    setPage(page - 1);
    onClickPrevPage && onClickPrevPage(page - 1);
    if(page === startRange) {
      setStartRange(startRange - 1);
      setEndRange(endRange - 1);
    }
  };

  const handleNextPage = () => {
    setPage(page + 1);
    onClickNextPage && onClickNextPage(page + 1);
    if(page === endRange) {
      setStartRange(startRange + 1);
      setEndRange(endRange + 1);
    }
  };

  const handleLastPage = () => {
    setPage(total);
    range > total ? setStartRange(PAGE.FIRST) : setStartRange(total - range + 1);
    setEndRange(total);
    onClickLastPage && onClickLastPage(total);
  };

  const handleCurrentPage = (page) => {
    setPage(page);
    onClickCurrentPage && onClickCurrentPage(page);
  };

  let isFirstPage = page === PAGE.FIRST;
  let isLastPage = page === total;
  let isCurrent = (item) => item === page;

  return(
    <Wrapper>
      { loading ? (
        <>
          <ActionPage disabled>
            <Icon name="chevrons-left"/>
          </ActionPage>
          <ActionPage disabled>
            <Icon name="chevron-left" />
          </ActionPage>
          <Content>
            <Shimmer.Line width="80px" height="26px"/>
          </Content>
          <ActionPage disabled>
            <Icon name="chevron-right" />
          </ActionPage>
          <ActionPage disabled>
          <Icon name="chevrons-right" />
          </ActionPage>
        </>
        ) : (
        <>
          <ActionPage onClick={handleFirstPage} disabled={isFirstPage}>
            <Icon name="chevrons-left" color="black" />
          </ActionPage>
          <ActionPage onClick={handlePrevPage} disabled={isFirstPage}>
            <Icon name="chevron-left" color="black" />
          </ActionPage>
          <Content>
            {items.map((item, key) => (
              <Page
                key={key}
                onClick={() => handleCurrentPage(item)}
                active={isCurrent(item)}
              >
                {item}
              </Page>
            ))}
          </Content>
          <ActionPage onClick={handleNextPage} disabled={isLastPage}>
            <Icon name="chevron-right" color="black" />
          </ActionPage>
          <ActionPage onClick={handleLastPage} disabled={isLastPage}>
            <Icon name="chevrons-right" color="black" />
          </ActionPage>
        </>
      )}
    </Wrapper>
  );
};

Pagination.propTypes = {
  loading: PropTypes.bool,
  defaultPage: PropTypes.number,
  totalPages: PropTypes.number.isRequired,
  range: PropTypes.number,
  onClickFirstPage: PropTypes.func,
  onClickPrevPage: PropTypes.func,
  onClickNextPage: PropTypes.func,
  onClickLastPage: PropTypes.func,
  onClickCurrentPage: PropTypes.func
};

Pagination.defaultProps = {
  defaultPage: 1,
  range: 4
};
